import { useEffect } from 'react';
import { toast } from 'react-toastify';

import { useMutation, useQuery } from '@tanstack/react-query';
import { apiServiceProxy } from 'v2/services/api-proxy';

export const useDownload = (hash: string) => {
  const listDownloads = useQuery({
    queryKey: ['downloadFile', hash],
    queryFn: async () => {
      const result = await apiServiceProxy.get<{ name: string; extension: string; url_download: string }[]>(
        `/downloadfile/${hash}`
      );
      return result.data;
    },
    enabled: !!hash
  });

  useEffect(() => {
    if (listDownloads.isError) {
      toast.error('Ops, erro na listagem de downloads');
    }
  }, [listDownloads.isError]);

  const downloadFile = useMutation({
    mutationFn: async (url: string) => {
      const hash = url.split('/').pop();
      const result = await apiServiceProxy.post('/validatedownloadhash', { hash });

      const isValid = result.data?.status;

      if (!isValid) {
        toast.error('Link de download inválido');
        return;
      }

      const link = document.createElement('a');
      link.setAttribute('download', 'true');
      link.href = url;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  });

  return {
    downloadFile: (url: string) => downloadFile.mutateAsync(url),
    isDownloading: listDownloads.isFetching,
    downloads: listDownloads.data
  };
};
